(function () {
  'use strict';
  var doc = document;
  var lastFocus = null;

  function setDrawer(open) {
    var d = doc.querySelector('[data-hoc-drawer]');
    if (!d) return;
    d.classList.toggle('is-open', open);
    d.setAttribute('aria-hidden', open ? 'false' : 'true');
    var btn = doc.querySelector('[data-hoc-drawer-open]');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    doc.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) {
      lastFocus = doc.activeElement;
      var c = d.querySelector('[data-hoc-drawer-close]');
      if (c) c.focus();
    } else if (lastFocus) {
      lastFocus.focus();
      lastFocus = null;
    }
  }

  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-hoc-drawer-open]')) { setDrawer(true); return; }
    if (t.closest('[data-hoc-drawer-close]')) { setDrawer(false); return; }
    if (t.closest('.hoc-drawer__nav a')) { setDrawer(false); return; }
    var arrow = t.closest('[data-hoc-slider-prev],[data-hoc-slider-next]');
    if (arrow) {
      var root = arrow.closest('[data-hoc-slider-root]');
      var track = root && root.querySelector('[data-hoc-slider]');
      if (!track) return;
      var card = track.firstElementChild;
      var step = card ? card.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
      track.scrollBy({ left: arrow.hasAttribute('data-hoc-slider-next') ? step : -step, behavior: 'smooth' });
    }
  });

  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setDrawer(false);
  });

  function updateSlider(track) {
    var root = track.closest('[data-hoc-slider-root]');
    if (!root) return;
    var prev = root.querySelector('[data-hoc-slider-prev]');
    var next = root.querySelector('[data-hoc-slider-next]');
    var max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
  }

  function initSliders() {
    doc.querySelectorAll('[data-hoc-slider]').forEach(function (track) {
      if (track.__hoc) return;
      track.__hoc = true;
      updateSlider(track);
      track.addEventListener('scroll', function () { updateSlider(track); }, { passive: true });
      window.addEventListener('resize', function () { updateSlider(track); });
    });
  }

  function initHeader() {
    var h = doc.querySelector('[data-hoc-header]');
    if (!h || h.__hoc) return;
    h.__hoc = true;
    var f = function () { h.classList.toggle('is-scrolled', window.scrollY > 6); };
    f();
    window.addEventListener('scroll', f, { passive: true });
  }

  function initReveal() {
    var els = doc.querySelectorAll('[data-hoc-reveal]');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() {
    window.__hocReady = true;
    initHeader();
    initSliders();
    initReveal();
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();
  doc.addEventListener('shopify:section:load', function () { initHeader(); initSliders(); });
})();
